/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FormController from "../../../FormController/FormController";
import { getGames } from "../../../../features/cms/cmsSlice";

import { DateRange } from "../../components/calendar/dateRange";

import sharedStyles from "../../SharedStyles.module.scss";
import styles from "./Home.module.scss";
import HomeButtom from "./HomeButtom";
import {
  adobeClickTracking,
  adobePageNameTracking,
} from "../../../../helpers/tracking";

const Home = () => {
  const history = useHistory();
  const topEl = useRef();
  const { type } = useSelector((state) => state.singleGroup);
  const games = useSelector(getGames);
  const [isOpen, setIsOpen] = useState(false);
  const [isUpcoming, setIsUpcoming] = useState(true);
  const handleSetIsOpen = (isUpcoming) => {
    setIsUpcoming(isUpcoming);
    setIsOpen(true);
  };

  useEffect(() => {
    if (!type) {
      history.push("/");
    } else {
      adobePageNameTracking({
        pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: ${
          type === "single" ? "Single Game" : "Group"
        } Tickets`,
      });
    }
  }, []);
  useEffect(() => {
    if (isOpen) {
      topEl.current.style.maxHeight = topEl.current.scrollHeight + "px";
    } else {
      topEl.current.removeAttribute("style");
    }
  }, [isOpen, games]);

  return (
    <div className={styles.body}>
      <h1 className={sharedStyles.header}>
        {type === "single"
          ? "Tickets to a Single Game"
          : "Tickets for a Large Group"}
      </h1>
      {/* <h3 className={sharedStyles.subHeader}>
        *a $10 processing fee will be added to all Orders at checkout
      </h3> */}
      <h3 className={sharedStyles.subHeader}>
        Choose your game from a season full of exciting giveaways, theme games,
        and special promotions. A $10 processing fee will be added to all orders at checkout.
      </h3>
      <div className={styles.top}>
        <div className={styles.buttons}>
          <div
            className={styles.button}
            onClick={() => {
              adobeClickTracking({
                prop13: `Washington Nationals: Tickets: Nationals Ticketfinder: ${
                  type === "single" ? "Single Game" : "Group"
                } Tickets`,
                prop14: `${
                  type === "single" ? "Single Game" : "Group"
                } Tickets: Upcoming Games Click`,
              });
              handleSetIsOpen(true);
            }}
          >
            <div className={styles.content}>
              <svg
                width="31"
                height="31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.507 29.757c7.735 0 14.006-6.271 14.006-14.007S23.243 1.743 15.507 1.743C7.77 1.743 1.5 8.014 1.5 15.75s6.271 14.007 14.007 14.007Z"
                  stroke="#000847"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M28.415 15.68A14.007 14.007 0 0 1 15.553 2.5M15.434 28.707A14.007 14.007 0 0 0 2.25 15.8"
                  stroke="#000847"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M18.297 4.997 13.878 6.28M19.966 8.463l-3.757 2.655M22.794 11.29l-2.656 3.758M26.26 12.96l-1.283 4.418M4.749 18.545l1.283-4.419M8.215 20.214l2.656-3.757M11.043 23.041l3.756-2.655M12.712 26.507l4.419-1.283"
                  stroke="#BA0C2F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className={styles.text}>
                <p>
                  Upcoming Games{" "}
                  <svg
                    width="11"
                    height="11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={styles.arrow}
                  >
                    <path
                      d="m4.106 10.75-1.11-1.104 3.838-3.833-3.98-3.959L3.964.75 9.07 5.813 4.106 10.75Z"
                      fill="#BA0C2F"
                    />
                  </svg>
                </p>
                {/* <div className={styles.desc}>Shows the next games.</div> */}
              </div>
            </div>
            <span></span>
          </div>
          <div
            className={styles.button}
            onClick={() => {
              adobeClickTracking({
                prop13: `Washington Nationals: Tickets: Nationals Ticketfinder: ${
                  type === "single" ? "Single Game" : "Group"
                } Tickets`,
                prop14: `${
                  type === "single" ? "Single Game" : "Group"
                } Tickets: Calendar View Click`,
              });
              handleSetIsOpen(false);
            }}
          >
            <div className={styles.content}>
              <svg
                width="32"
                height="32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="1.003"
                  y="4.306"
                  width="29.447"
                  height="26.125"
                  rx="2"
                  stroke="#000847"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.991 1.743v3.813M24.462 1.743v3.813M29.921 9.056H1.531"
                  stroke="#000847"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="m18.513 16.577 2.566-1.948h.27v10.23M11.886 19.416c.539 0 1.524-.26 2.17-.941.212-.218.38-.477.492-.762.113-.285.17-.59.166-.898 0-1.59-1.335-2.43-2.83-2.43-1.265 0-1.981.707-2.237 1.153M9.353 23.528c.288.504 1.165 1.574 2.593 1.574 1.69 0 3.08-.97 3.08-2.668 0-.769-.216-1.462-.684-1.953-.73-.77-1.847-1.065-2.455-1.065"
                  stroke="#BA0C2F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className={styles.text}>
                <p>
                  Calendar View{" "}
                  <svg
                    width="11"
                    height="11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={styles.arrow}
                  >
                    <path
                      d="m4.106 10.75-1.11-1.104 3.838-3.833-3.98-3.959L3.964.75 9.07 5.813 4.106 10.75Z"
                      fill="#BA0C2F"
                    />
                  </svg>
                </p>
                {/* <div className={styles.desc}>Enter a specific game date.</div> */}
              </div>
            </div>
            <span></span>
          </div>
        </div>
        <div className={styles.dateRange} ref={topEl}>
          {type && <DateRange isUpcoming={isUpcoming} />}
        </div>
      </div>
      <div className={styles.bottom}>
        <HomeButtom type={type} />
      </div>
      <FormController
        backTo={type === "single" ? "/" : "/ticket-group-home"}
        startOver="/"
        showBack
        showStartOver
      />
    </div>
  );
};

export default Home;
